export default function Search() {
  return (
    <svg viewBox="0 0 20 20">
      <circle
        cx="6.563"
        cy="6.563"
        r="6.563"
        transform="translate(2.5 2.5)"
        fill="none"
        stroke="#fff"
      />
      <path fill="none" stroke="#fff" d="M13.703 13.703 17.5 17.5" />
    </svg>
  );
}
